import React, { useEffect, useState } from 'react'
import { Col, Form, InputGroup, Row, Table } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { formatFecha, getTableBd, insertTableBd, updateTableBd } from '../../config/functions'

export const DOReportToneladasMilla = ({
    idrde,
    user,
    mobile
}) => {

    const [registro, setRegistro] = useState(null)
    const [esNuevo, setEsNuevo] = useState(true)
    const [editando, setEditando] = useState(false)

    const [fechaUltimaCorrida, setFechaUltimaCorrida] = useState('')
    const [fechaUltimaCortada, setFechaUltimaCortada] = useState('')
    const [longitudCorrida, setLongitudCorrida] = useState(0)
    const [longitudCortada, setLongitudCortada] = useState(0)
    const [anterior, setAnterior] = useState(0)
    const [hoy, setHoy] = useState(0)
    const [total, setTotal] = useState(0)
    const [cableRemanente, setCableRemanente] = useState(0)

    const [verificado, setVerificado] = useState(false)
    const [usuarioVerifica, setUsuarioVerifica] = useState('')
    const [fechaVerifica, setFechaVerifica] = useState('')

    // Auto-calcular total
    useEffect(() => {
        setTotal(parseFloat(anterior || 0) + parseFloat(hoy || 0))
    }, [anterior, hoy])

    // Cargar datos
    useEffect(() => {
        if (idrde) {
            getDatos()
        }
    }, [idrde])

    const getDatos = async () => {
        try {
            const data = await getTableBd('getToneladasMillaRDE/' + idrde)
            if (data.length > 0) {
                const reg = data[0]
                setRegistro(reg)
                setEsNuevo(false)
                setEditando(false)
                setFechaUltimaCorrida(reg.fecha_ultima_corrida ? reg.fecha_ultima_corrida.split('T')[0] : '')
                setFechaUltimaCortada(reg.fecha_ultima_cortada ? reg.fecha_ultima_cortada.split('T')[0] : '')
                setLongitudCorrida(reg.longitud_corrida || 0)
                setLongitudCortada(reg.longitud_cortada || 0)
                setAnterior(reg.anterior || 0)
                setHoy(reg.hoy || 0)
                setTotal(reg.total || 0)
                setCableRemanente(reg.cable_remanente || 0)
                setUsuarioVerifica(reg.usuario_verifica || '')
                setFechaVerifica(reg.fecha_verifica || '')
                setVerificado(reg.usuario_verifica !== '' && reg.usuario_verifica !== null)
            } else {
                setEsNuevo(true)
                setEditando(false)
                setRegistro(null)
                setVerificado(false)
                setUsuarioVerifica('')
            }
        } catch (error) {
            console.error(error)
        }
    }

    const camposDeshabilitados = verificado || (!esNuevo && !editando)

    const guardar = async () => {
        const dataSend = {
            id_rde: idrde,
            fecha_ultima_corrida: fechaUltimaCorrida || null,
            fecha_ultima_cortada: fechaUltimaCortada || null,
            longitud_corrida: longitudCorrida,
            longitud_cortada: longitudCortada,
            anterior: anterior,
            hoy: hoy,
            total: total,
            cable_remanente: cableRemanente,
            usuario: user
        }

        try {
            if (esNuevo) {
                await insertTableBd('createToneladasMilla', dataSend)
                toast.success('Toneladas Milla guardado')
            } else {
                dataSend.id = registro.id
                await updateTableBd('updateToneladasMilla', dataSend)
                toast.success('Toneladas Milla actualizado')
            }
            getDatos()
        } catch (error) {
            console.error(error)
            toast.error('Error al guardar Toneladas Milla')
        }
    }

    const verificar = async () => {
        if (esNuevo) {
            toast.warning('Debe guardar primero el registro')
            return
        }
        if (!window.confirm('¿Está seguro de verificar Toneladas Milla? Una vez verificado no se podrá editar.')) return

        const now = new Date()
        now.setHours(now.getHours() - 5)
        const dataSend = {
            id: registro.id,
            usuario_verifica: user,
            fecha_verifica: now.toISOString()
        }

        try {
            await updateTableBd('verificarToneladasMilla', dataSend)
            toast.success('Toneladas Milla verificado')
            getDatos()
        } catch (error) {
            console.error(error)
            toast.error('Error al verificar')
        }
    }

    const inputField = (label, value, setter, type = 'number', suffix = '') => (
        <InputGroup className="mb-2" size="sm">
            <InputGroup.Text style={{ minWidth: mobile ? '120px' : '180px' }}>
                {label}
            </InputGroup.Text>
            <Form.Control
                type={type}
                size="sm"
                value={value}
                disabled={camposDeshabilitados}
                onChange={(e) => setter(type === 'number' ? parseFloat(e.target.value) || 0 : e.target.value)}
                step={type === 'number' ? '0.01' : undefined}
            />
            {suffix && <InputGroup.Text>{suffix}</InputGroup.Text>}
        </InputGroup>
    )

    return (
        <div className="mt-2">
            {verificado && (
                <Row className="justify-content-md-center mb-2">
                    <h6 className='text-success'>Verificado por: {usuarioVerifica}</h6>
                    <h6 className='text-success'>Fecha Verificación: {formatFecha(fechaVerifica)}</h6>
                </Row>
            )}

            <Row className="mt-2 justify-content-md-center">
                <Col className="text-center">
                    <h5 style={{ fontSize: mobile && '16px' }}>Toneladas Milla</h5>
                </Col>
            </Row>

            <Row className="mt-2">
                <Col sm={6}>
                    {inputField('Fecha Últ. Corrida', fechaUltimaCorrida, setFechaUltimaCorrida, 'date')}
                </Col>
                <Col sm={6}>
                    {inputField('Fecha Últ. Cortada', fechaUltimaCortada, setFechaUltimaCortada, 'date')}
                </Col>
            </Row>

            <Row>
                <Col sm={6}>
                    {inputField('Longitud Corrida', longitudCorrida, setLongitudCorrida, 'number', 'FT')}
                </Col>
                <Col sm={6}>
                    {inputField('Longitud Cortada', longitudCortada, setLongitudCortada, 'number', 'FT')}
                </Col>
            </Row>

            <Row>
                <Col sm={4}>
                    {inputField('Anterior', anterior, setAnterior)}
                </Col>
                <Col sm={4}>
                    {inputField('Hoy', hoy, setHoy)}
                </Col>
                <Col sm={4}>
                    <InputGroup className="mb-2" size="sm">
                        <InputGroup.Text style={{ minWidth: mobile ? '120px' : '180px' }} className="bg-light fw-bold">
                            Total
                        </InputGroup.Text>
                        <Form.Control
                            type="number"
                            size="sm"
                            value={total}
                            disabled={true}
                            className="bg-light fw-bold"
                        />
                    </InputGroup>
                </Col>
            </Row>

            <Row>
                <Col sm={6}>
                    {inputField('Cable Remanente', cableRemanente, setCableRemanente, 'number', 'FT')}
                </Col>
            </Row>

            {!verificado && (
                <Row className="mt-2 mb-3 justify-content-md-center">
                    <Col xs="auto">
                        {esNuevo ? (
                            <button
                                className='btn btn-sm btn-outline-primary'
                                onClick={guardar}>
                                <i className="fa-solid fa-floppy-disk me-1"></i> Guardar
                            </button>
                        ) : !editando ? (
                            <button
                                className='btn btn-sm btn-outline-secondary'
                                onClick={() => setEditando(true)}>
                                <i className="fa-solid fa-pen-to-square me-1"></i> Editar
                            </button>
                        ) : (
                            <div className="btn-group">
                                <button
                                    className='btn btn-sm btn-outline-primary'
                                    onClick={guardar}>
                                    <i className="fa-solid fa-floppy-disk me-1"></i> Guardar
                                </button>
                                <button
                                    className='btn btn-sm btn-outline-secondary'
                                    onClick={() => { setEditando(false); getDatos() }}>
                                    <i className="fa-solid fa-xmark me-1"></i> Cancelar
                                </button>
                            </div>
                        )}
                    </Col>
                    {!esNuevo && (
                        <Col xs="auto">
                            <button
                                className='btn btn-sm btn-outline-success'
                                onClick={verificar}>
                                <i className="fa-solid fa-check-double me-1"></i> Verificar
                            </button>
                        </Col>
                    )}
                </Row>
            )}
        </div>
    )
}
